import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import defaultOptionalForm from '../../../api/data-dummy/default-optional-form.json';
import Header from '../../../components/header/Header';
import UserInfoForm from '../../../components/UserInfoForm/UserInfoForm';

import { localStorageKeys } from '../../../utils/Constants';
import { useFujiAuth } from '../../../auth/useFujiAuth';
import styles from './styles.module.css';
import { useReservationFlow } from '../../../hooks/useReservationFlow';

const ReservationUserInfoScreen = () => {
    const { t } = useTranslation();

    const { next, back, ticketInfo, isEdit, localReservation } = useReservationFlow();
    // const localFormFieldsWithUser = JSON.parse(localStorage.getItem(localStorageKeys.FORM_VALUE_WITH_USER) || '{}');
    const { user } = useFujiAuth();
    const { email } = user ?? {};

    const optionalForm = useMemo(() => {
        const visibleOptionalForm = ticketInfo?.optionalForm?.filter((field: any) => field.isVisible);
        const combined: any = {};
        defaultOptionalForm?.forEach((item) => {
            combined[item.key] = item;
        });
        visibleOptionalForm?.forEach((item: any) => {
            combined[item.key] = item;
        });
        return Object.values(combined);
    }, [ticketInfo, defaultOptionalForm]);

    const initialFormValues = useMemo(() => {
        const isPrivateRelayEmail = (email: string) => {
            if (!email) {
                return false;
            }
            const domain = email.split('@')[1];
            return domain === 'privaterelay.appleid.com';
        };
        const userEmail = !isPrivateRelayEmail(email) ? email : null;
        const localFormFieldsWithUserId = { email: userEmail };
        const localFormFields = localReservation?.userInfo?.formFields ?? {};
        const initialFormValues = { ...localFormFieldsWithUserId, ...localFormFields };
        return { ...initialFormValues, confirm: initialFormValues.email };
    }, [localReservation?.userInfo?.formFields, email]);

    const handleFormSubmit = async (form: any) => {
        const listFields: any = [];
        optionalForm?.forEach(({ label, key }: any) => {
            const field = { key: key, value: form[key], label: label };
            listFields.push(field);
        });
        localStorage.setItem(
            localStorageKeys.RESERVATION_INFO_DATA,
            JSON.stringify({ ...localReservation, userInfo: { listFields, formFields: form } }),
        );
        // if (isSaveUserInfo) {
        //     localStorage.setItem(
        //         localStorageKeys.FORM_VALUE_WITH_USER,
        //         JSON.stringify({
        //             ...localFormFieldsWithUser,
        //             [userId]: {
        //                 representativeName: form.representativeName,
        //                 phoneNumber: form.phoneNumber,
        //                 countryCode: form.countryCode,
        //                 email: form.email,
        //             },
        //         }),
        //     );
        // }
        next('user-info');
    };

    return (
        <>
            <Header
                title={!isEdit ? t('header.buy-ticket') : t('reservation.header')}
                callback={() => back('user-info')}
            />
            <div className="content-container scrollable">
                {/* 個人情報入力 */}
                {/* <p className={styles.screenName}>{t('reservation.input-user-info')}</p> */}
                <div className={styles.userInfoForm}>
                    <UserInfoForm
                        formFields={optionalForm}
                        initialValues={initialFormValues}
                        onFormSubmit={handleFormSubmit}
                    />
                </div>
            </div>
        </>
    );
};
export default ReservationUserInfoScreen;
